// extracted by mini-css-extract-plugin
export default {"PanelContent-container":"PanelContent-container3TZBQq7Vni3K"};